<template>
  <div>
    <el-table
      :ref="tableName"
      v-if="tableHack"
      :data="data"
      v-bind="$props"
      border="border"
      class="ccui-multifunctional-table"
      @select-all="handleCheckAllChange"
      @select="handleCheckChange"
      @selection-change="handleSelectionChange"
      @header-dragend="setTableTitleWidth"
      @row-click="handleRowClick"
      @sort-change="changeSort"
      @row-dblclick="rowDblClick"
      :empty-text="$t('page.content.noData')"
    >
      <el-table-column type="selection" width="28" v-if="showCheckBox" />
      <template v-for="(table, index) in tableTheadOptions">
        <el-table-column
          v-if="table.checked"
          :fixed="table.fixed || false"
          :key="index"
          :type="table.type"
          :label="table.label"
          :width="table.width"
          :min-width="table.minWidth"
          :prop="table.prop"
          :align="table.align || 'left'"
          :header-align="table.headerAlign || 'left'"
          :filters="table.filters"
          :formatter="table.formatter"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--render函数Begin-->
            <!--            <ex-slot v-if="table.render" :render="table.render" :row="scope.row" :index="scope.$index" :column="table" />-->
            <!--            <span v-else>{{ scope.row[table.prop] || '-' }}</span>-->
            <!--render函数End-->
            <!--slot插槽Begin-->
            <slot
              v-if="table.slot"
              :row="scope.row"
              :$index="scope.$index"
              :name="table.slot"
            />
            <template v-else-if="table.type === 'index'">
              {{ scope.$index + 1 }}
            </template>
            <template v-else>
              {{ scope.row[table.prop] || "-" }}
            </template>
            <!--slot插槽End-->
          </template>
        </el-table-column>
      </template>
      <el-table-column
        label="操作"
        :width="showOpObj.width"
        fixed="right"
        v-if="showOp"
      >
        <template slot-scope="{ row, $index }">
          <slot :row="row" :$index="$index" name="op" />
        </template>
        <template v-slot:header v-if="showOpObj.showOpSetting">
          <div class="ccui-multifunctional-table-wrapper-operation">
            <span>操作</span>
            <el-popover
              placement="right"
              popper-class="ccui-multifunctional-table-wrapper_setting__popover"
              trigger="click"
            >
              <el-checkbox
                v-for="(e, i) in props_fixedTableThead"
                :key="i"
                :checked="e.checked"
                disabled
                class="ccui-popover-disabled"
                >{{ e.label }}</el-checkbox
              >
              <div class="ccui-popover-line"></div>
              <draggable
                :list="props_unfixedTableThead"
                class="ccui-draggable"
                @change="handleTableChange"
              >
                <el-checkbox-group
                  v-for="(item, index) in props_unfixedTableThead"
                  v-model="item.checked"
                  :key="item.prop + index"
                >
                  <el-checkbox
                    :label="item"
                    :checked="item.checked"
                    :width="item.width"
                    :title="item.label"
                    @change="handleUpdate(item, index)"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </draggable>
              <i
                class="el-icon-s-tools ccui-multifunctional-table-wrapper_setting__icon"
                slot="reference"
              ></i>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!--分页Begin-->
    <div class="ccui-table-footer" v-show="data.length > 0">
      <div class="ccui-operation">
        <slot name="batchOp"></slot>
      </div>

      <div id="ccui-paging" :class="{ paginationEn: !languagezh_cn }">
        <el-pagination
          :total="pageTotal"
          :page-size="pageSize"
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100, 200, 500]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          popper-class="ccui-paging-page-size-popper"
          @prev-click="handlePrev"
          @next-click="handleNext"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <el-button
          class="ccui-pagination-btn"
          size="mini"
          type="default"
          @click="handleSizeChange('none')"
          >确定</el-button
        >
      </div>
    </div>
    <!--分页End-->
  </div>
</template>

<script>
import util from "@/basa/utils/util";
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  props: {
    showCheckBox: {
      type: Boolean,
      default: false
    },
    showOp: {
      // 是否展示操作列
      type: Boolean,
      default: true
    },
    showOpObj: {
      type: Object,
      default() {
        return {
          showOpSetting: false,
          width: 100
        };
      }
    },
    tableName: {
      // 必传 这个是唯一值
      type: String,
      default: ""
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    fixedTableThead: {
      type: Array,
      default: () => []
    },
    unfixedTableThead: {
      type: Array,
      default: () => []
    },
    pageNo: {
      type: Number,
      default: 1
    },
    pageTotal: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  created() {
    // console.log("liangqingzhuCreated");
  },
  data() {
    return {
      tableHack: true,
      tableTheadOptions: [],
      props_fixedTableThead: [],
      props_unfixedTableThead: [],
      props_pageNo: this.pageNo,
      props_pageSize: this.pageSize
    };
  },
  activated() {
    // console.log("liangqingzhuActived");

    this.$nextTick(() => {
      this.$refs[this.tableName].doLayout();
      this.$refs[this.tableName].bodyWrapper.scrollLeft = 0;
    });
  },
  watch: {
    // 监听表格的编号
    tableName(val) {
      this.renderTable();
    }
  },
  mounted() {
    this.renderTable();
  },
  methods: {
    // 默认渲染表格
    renderTable() {
      console.log(this.tableName);

      this.$nextTick(() => {
        this.$refs[this.tableName].doLayout();
        this.$refs[this.tableName].bodyWrapper.scrollLeft = 0;
      });
      this.props_fixedTableThead = this.fixedTableThead;
      this.props_unfixedTableThead = this.unfixedTableThead;
      /**tableName为空的时候不去查找本地缓存[为了兼容]Begin**/
      if (this.tableName === "" || this.showOpObj.showOpSetting === false) {
        // console.log("没有表格名称或者高级设置为false");
        this.tableTheadOptions = this.props_fixedTableThead.concat(
          this.props_unfixedTableThead
        );
        this.tableTheadOptions = this.tableTheadOptions.map(item => {
          item.checked = true;
          return item;
        });
        return false;
      }
      /**tableName为空的时候不去查找本地缓存End**/

      /**tableName不为空的时候不去查找本地缓存Begin**/

      const localTableData = util.db.get(`table[${this.tableName}]`).value()
        ? JSON.parse(util.db.get(`table[${this.tableName}]`).value())
        : [];
      let unfixedTableThead = this.props_fixedTableThead.concat(
        this.props_unfixedTableThead
      );
      let localTableDataStr = localTableData.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );
      let unfixedTableTheadStr = unfixedTableThead.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );
      if (localTableData.length === unfixedTableThead.length) {
        /***本地存储的和设置的长度相同***/
        let flag = localTableDataStr.every(item =>
          unfixedTableTheadStr.includes(item)
        );
        if (flag) {
          // 完全相同
          this.tableTheadOptions = localTableData;
          this.tableThead = localTableData;
          this.props_unfixedTableThead = localTableData.filter(item => {
            return !this.props_fixedTableThead.find(
              cItem => item.prop === cItem.prop
            );
          });
        } else {
          // 长度相同但值不同
          this.tableThead = this.props_fixedTableThead.concat(
            this.props_unfixedTableThead
          );
          const comment = JSON.stringify(this.tableThead);
          localStorage.setItem(this.tableName, comment);
          const localTableData = JSON.parse(
            util.db.get(`table[${this.tableName}]`).value()
          );
          this.tableTheadOptions = localTableData;
        }
      } else {
        /***本地存储的和设置的列不相等***/
        this.tableThead = this.props_fixedTableThead.concat(
          this.props_unfixedTableThead
        );
        const comment = JSON.stringify(this.tableThead);
        util.db.set(`table[${this.tableName}]`, comment).write();
        const localTableData = JSON.parse(
          util.db.get(`table[${this.tableName}]`).value()
        );
        this.tableTheadOptions = localTableData;
      }
    },
    /**tableName不为空的时候不去查找本地缓存End**/
    setTableTitleWidth(newWidth, oldWidth, column, event) {
      /**表格宽度更改存入**/
      for (let i = 0; i < this.props_unfixedTableThead.length; i++) {
        if (this.props_unfixedTableThead[i].label === column.label) {
          this.props_unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.props_fixedTableThead.concat(
        this.props_unfixedTableThead
      );
      const comment = JSON.stringify(this.tableThead);
      util.db.set(`table[${this.tableName}]`, comment).write();
      this.tableTheadOptions = JSON.parse(
        util.db.get(`table[${this.tableName}]`).value()
      );
      this.tableHack = false;
      this.$nextTick(() => {
        this.tableHack = true;
      });
    },
    handleRowClick(row, column, event) {
      this.$emit("handleRowClick", row);
    },
    rowDblClick(row, column, event) {
      this.$emit("rowDblClick", row);
    },
    getList(obj) {
      this.$emit("update:pageNo", obj.pageNo);
      this.$emit("update:pageSize", obj.pageSize);
      this.$emit("handleList", obj);
    },
    handlePrev() {
      --this.props_pageNo;
      let obj = {
        pageNo: this.props_pageNo,
        pageSize: this.props_pageSize
      };
      this.getList(obj);
    },
    handleNext() {
      ++this.props_pageNo;
      let obj = {
        pageNo: this.props_pageNo,
        pageSize: this.props_pageSize
      };
      this.getList(obj);
    },
    handleSizeChange(val) {
      this.props_pageNo = 1;
      if (val !== "none") {
        this.props_pageSize = val;
        // setSessionItem("pageSize", this.tableName, val);
      }
      let obj = {
        pageNo: this.props_pageNo,
        pageSize: this.props_pageSize
      };
      this.getList(obj);
    },
    handleCurrentChange(val) {
      // let searchFormData = getSessionItem("pageNo", this.tableName) || {};
      // setSessionItem("pageNo", this.tableName, {
      //   pageNo: val,
      //   searchForm: searchFormData.searchForm || {}
      // });
      this.props_pageNo = val;
      let obj = {
        pageNo: this.props_pageNo,
        pageSize: this.props_pageSize
      };
      this.getList(obj);
    },
    // 表格弹框拖拽触发
    handleTableChange(val) {
      this.tableThead = this.props_fixedTableThead.concat(
        this.props_unfixedTableThead
      );
      const comment = JSON.stringify(this.tableThead);
      util.db.set(`table[${this.tableName}]`, comment).write();
      const localTableData = JSON.parse(
        util.db.get(`table[${this.tableName}]`).value()
      );
      this.tableTheadOptions = localTableData;
    },
    // 是否显示对应列
    handleUpdate(item, index) {
      // for (let i = 0; i < this.props_unfixedTableThead.length; i++) {
      //   if (i === index) {
      //     this.props_unfixedTableThead.checked = !this.props_unfixedTableThead.checked;
      //   }
      // }
      this.tableThead = this.props_fixedTableThead.concat(
        this.props_unfixedTableThead
      );
      const comment = JSON.stringify(this.tableThead);
      util.db.set(`table[${this.tableName}]`, comment).write();
      const localTableData = JSON.parse(
        util.db.get(`table[${this.tableName}]`).value()
      );
      this.tableTheadOptions = localTableData;
    },
    handleCheckAllChange(val) {
      this.$emit("select-all", val);
    },
    handleCheckChange(val) {
      this.$emit("select", val);
    },
    handleSelectionChange(val) {
      this.$emit("selection-change", val);
    },
    changeSort(val) {
      this.$emit("sort-change", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.paginationEn {
  /deep/ .el-pagination .el-select .el-input {
    width: 125px !important;
  }
}
</style>
